import moment from 'moment'

export const dateToHuman = (date) => {
  return moment(date, 'YYYY-MM-DD').format('dddd, DD [de] MMMM [de] YYYY')
}

export const datetimeToHuman = (date) => {
  return moment(date, 'YYYY-MM-DDThh:mm').format('dddd, DD [de] MMMM [de] YYYY [às] HH:mm')
}

export const shortDateToHuman = (date) => {
  return moment(date, 'YYYY-MM-DD').format('DD[,] MMMM YY')
}

export const formatDate = (date, format, format_entrie='YYYY-MM-DD HH:mm:ss') => {
  return moment(date, format_entrie).utc().local().format(format)
}

export const brDate = (date) => {
  return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
}

export const dateToHour = (date) => {
  return moment.parseZone(date).format('HH:mm')
}

export const minutesToHours = (minutes) => {
  return String(Math.floor(minutes/60)) + 'h ' + String(minutes % 60) + 'm'
}

export const dateToWeekday = (date) => {
  return moment(date, 'YYYY-MM-DDThh:mm').format('ddd, D [de] MMM')
}

export const dateToMonthday = (date) => {
  return moment(date, 'YYYY-MM-DDThh:mm').format('D [de] MMMM')
}

export const subtractDatesToHours = (dates) => {
  const date_start = moment(dates[0])
  const date_end = moment(dates[1])
  const minutes = date_end.diff(date_start, 'minutes')
  return String(Math.floor(minutes/60)) + 'h ' + String(minutes % 60) + 'm'
}
